/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * LeadSweet Discovery API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AddSmartscoutImportRowsBody,
  AddSmartscoutImportRowsResponse,
  AuthUser,
  CreateListBody,
  CreateNoteBody,
  CreateNoteCommentBody,
  CreatePipelineRunBody,
  CreateSmartscoutImportBody,
  DiscoveryCountParams,
  DiscoveryCountResponse,
  DiscoverySearchParams,
  DiscoverySearchResponse,
  ExportBody,
  ExportQuote,
  ExportResult,
  ForgotPasswordBody,
  GetNoteContextParams,
  GetPipelineLimitsResponse,
  GetPipelineRunParams,
  GetPipelineRunResponse,
  HealthStatus,
  ListNotesParams,
  ListPipelineRunsResponse,
  ListUnlockedSellersParams,
  LoginBody,
  LookupSellerParams,
  MeResponse,
  Note,
  NoteContext,
  NoteListResponse,
  OkResponse,
  PipelineRun,
  PromotePipelineRunResponse,
  ResendVerificationBody,
  ResetPasswordBody,
  SampleRequestBody,
  SavedList,
  SeedPipelineBody,
  SeedPipelineResponse,
  SellerDetail,
  SellerLookupResponse,
  SellerOpener,
  SignupBody,
  SmartscoutImport,
  SmartscoutImportList,
  UnlockResponse,
  UnlockedSellersResponse,
  UpdateListBody,
  UpdateNoteStatusBody,
  UpdatePipelineLimitsBody,
  VerifyEmailBody,
  VerifyEmailResponse,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new user account
 */
export const getSignupUrl = () => {
  return `/api/auth/signup`;
};

export const signup = async (
  signupBody: SignupBody,
  options?: RequestInit,
): Promise<AuthUser> => {
  return customFetch<AuthUser>(getSignupUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(signupBody),
  });
};

export const getSignupMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signup>>,
    TError,
    { data: BodyType<SignupBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signup>>,
  TError,
  { data: BodyType<SignupBody> },
  TContext
> => {
  const mutationKey = ["signup"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signup>>,
    { data: BodyType<SignupBody> }
  > = (props) => {
    const { data } = props ?? {};

    return signup(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignupMutationResult = NonNullable<
  Awaited<ReturnType<typeof signup>>
>;
export type SignupMutationBody = BodyType<SignupBody>;
export type SignupMutationError = ErrorType<unknown>;

/**
 * @summary Create a new user account
 */
export const useSignup = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signup>>,
    TError,
    { data: BodyType<SignupBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof signup>>,
  TError,
  { data: BodyType<SignupBody> },
  TContext
> => {
  return useMutation(getSignupMutationOptions(options));
};

/**
 * @summary Log in
 */
export const getLoginUrl = () => {
  return `/api/auth/login`;
};

export const login = async (
  loginBody: LoginBody,
  options?: RequestInit,
): Promise<AuthUser> => {
  return customFetch<AuthUser>(getLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(loginBody),
  });
};

export const getLoginMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginBody> },
  TContext
> => {
  const mutationKey = ["login"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    { data: BodyType<LoginBody> }
  > = (props) => {
    const { data } = props ?? {};

    return login(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;
export type LoginMutationBody = BodyType<LoginBody>;
export type LoginMutationError = ErrorType<unknown>;

/**
 * @summary Log in
 */
export const useLogin = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginBody> },
  TContext
> => {
  return useMutation(getLoginMutationOptions(options));
};

/**
 * @summary Log out
 */
export const getLogoutUrl = () => {
  return `/api/auth/logout`;
};

export const logout = async (options?: RequestInit): Promise<OkResponse> => {
  return customFetch<OkResponse>(getLogoutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getLogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["logout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logout>>,
    void
  > = () => {
    return logout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof logout>>
>;

export type LogoutMutationError = ErrorType<unknown>;

/**
 * @summary Log out
 */
export const useLogout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLogoutMutationOptions(options));
};

/**
 * @summary Current user
 */
export const getGetMeUrl = () => {
  return `/api/auth/me`;
};

export const getMe = async (options?: RequestInit): Promise<MeResponse> => {
  return customFetch<MeResponse>(getGetMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMeQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<unknown>;

/**
 * @summary Current user
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Confirm an email-verification token (grants the free credits)
 */
export const getVerifyEmailUrl = () => {
  return `/api/auth/verify-email`;
};

export const verifyEmail = async (
  verifyEmailBody: VerifyEmailBody,
  options?: RequestInit,
): Promise<VerifyEmailResponse> => {
  return customFetch<VerifyEmailResponse>(getVerifyEmailUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(verifyEmailBody),
  });
};

export const getVerifyEmailMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyEmail>>,
    TError,
    { data: BodyType<VerifyEmailBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyEmail>>,
  TError,
  { data: BodyType<VerifyEmailBody> },
  TContext
> => {
  const mutationKey = ["verifyEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyEmail>>,
    { data: BodyType<VerifyEmailBody> }
  > = (props) => {
    const { data } = props ?? {};

    return verifyEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyEmail>>
>;
export type VerifyEmailMutationBody = BodyType<VerifyEmailBody>;
export type VerifyEmailMutationError = ErrorType<unknown>;

/**
 * @summary Confirm an email-verification token (grants the free credits)
 */
export const useVerifyEmail = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyEmail>>,
    TError,
    { data: BodyType<VerifyEmailBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyEmail>>,
  TError,
  { data: BodyType<VerifyEmailBody> },
  TContext
> => {
  return useMutation(getVerifyEmailMutationOptions(options));
};

/**
 * @summary Resend the verification email (always 200 to avoid enumeration)
 */
export const getResendVerificationUrl = () => {
  return `/api/auth/resend-verification`;
};

export const resendVerification = async (
  resendVerificationBody: ResendVerificationBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getResendVerificationUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(resendVerificationBody),
  });
};

export const getResendVerificationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendVerification>>,
    TError,
    { data: BodyType<ResendVerificationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendVerification>>,
  TError,
  { data: BodyType<ResendVerificationBody> },
  TContext
> => {
  const mutationKey = ["resendVerification"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendVerification>>,
    { data: BodyType<ResendVerificationBody> }
  > = (props) => {
    const { data } = props ?? {};

    return resendVerification(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendVerificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendVerification>>
>;
export type ResendVerificationMutationBody = BodyType<ResendVerificationBody>;
export type ResendVerificationMutationError = ErrorType<unknown>;

/**
 * @summary Resend the verification email (always 200 to avoid enumeration)
 */
export const useResendVerification = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendVerification>>,
    TError,
    { data: BodyType<ResendVerificationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resendVerification>>,
  TError,
  { data: BodyType<ResendVerificationBody> },
  TContext
> => {
  return useMutation(getResendVerificationMutationOptions(options));
};

/**
 * @summary Request a password reset link (always 200 to avoid enumeration)
 */
export const getForgotPasswordUrl = () => {
  return `/api/auth/forgot-password`;
};

export const forgotPassword = async (
  forgotPasswordBody: ForgotPasswordBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getForgotPasswordUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(forgotPasswordBody),
  });
};

export const getForgotPasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof forgotPassword>>,
    TError,
    { data: BodyType<ForgotPasswordBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof forgotPassword>>,
  TError,
  { data: BodyType<ForgotPasswordBody> },
  TContext
> => {
  const mutationKey = ["forgotPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof forgotPassword>>,
    { data: BodyType<ForgotPasswordBody> }
  > = (props) => {
    const { data } = props ?? {};

    return forgotPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ForgotPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof forgotPassword>>
>;
export type ForgotPasswordMutationBody = BodyType<ForgotPasswordBody>;
export type ForgotPasswordMutationError = ErrorType<unknown>;

/**
 * @summary Request a password reset link (always 200 to avoid enumeration)
 */
export const useForgotPassword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof forgotPassword>>,
    TError,
    { data: BodyType<ForgotPasswordBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof forgotPassword>>,
  TError,
  { data: BodyType<ForgotPasswordBody> },
  TContext
> => {
  return useMutation(getForgotPasswordMutationOptions(options));
};

/**
 * @summary Consume a reset token and set a new password
 */
export const getResetPasswordUrl = () => {
  return `/api/auth/reset-password`;
};

export const resetPassword = async (
  resetPasswordBody: ResetPasswordBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getResetPasswordUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(resetPasswordBody),
  });
};

export const getResetPasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetPassword>>,
    TError,
    { data: BodyType<ResetPasswordBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetPassword>>,
  TError,
  { data: BodyType<ResetPasswordBody> },
  TContext
> => {
  const mutationKey = ["resetPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetPassword>>,
    { data: BodyType<ResetPasswordBody> }
  > = (props) => {
    const { data } = props ?? {};

    return resetPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetPassword>>
>;
export type ResetPasswordMutationBody = BodyType<ResetPasswordBody>;
export type ResetPasswordMutationError = ErrorType<unknown>;

/**
 * @summary Consume a reset token and set a new password
 */
export const useResetPassword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetPassword>>,
    TError,
    { data: BodyType<ResetPasswordBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetPassword>>,
  TError,
  { data: BodyType<ResetPasswordBody> },
  TContext
> => {
  return useMutation(getResetPasswordMutationOptions(options));
};

/**
 * @summary Search sellers
 */
export const getDiscoverySearchUrl = (params?: DiscoverySearchParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/discovery/search?${stringifiedParams}`
    : `/api/discovery/search`;
};

export const discoverySearch = async (
  params?: DiscoverySearchParams,
  options?: RequestInit,
): Promise<DiscoverySearchResponse> => {
  return customFetch<DiscoverySearchResponse>(getDiscoverySearchUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getDiscoverySearchQueryKey = (params?: DiscoverySearchParams) => {
  return [`/api/discovery/search`, ...(params ? [params] : [])] as const;
};

export const getDiscoverySearchQueryOptions = <
  TData = Awaited<ReturnType<typeof discoverySearch>>,
  TError = ErrorType<unknown>,
>(
  params?: DiscoverySearchParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof discoverySearch>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDiscoverySearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof discoverySearch>>> = ({
    signal,
  }) => discoverySearch(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof discoverySearch>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DiscoverySearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof discoverySearch>>
>;
export type DiscoverySearchQueryError = ErrorType<unknown>;

/**
 * @summary Search sellers
 */

export function useDiscoverySearch<
  TData = Awaited<ReturnType<typeof discoverySearch>>,
  TError = ErrorType<unknown>,
>(
  params?: DiscoverySearchParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof discoverySearch>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDiscoverySearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Total + facets only
 */
export const getDiscoveryCountUrl = (params?: DiscoveryCountParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/discovery/count?${stringifiedParams}`
    : `/api/discovery/count`;
};

export const discoveryCount = async (
  params?: DiscoveryCountParams,
  options?: RequestInit,
): Promise<DiscoveryCountResponse> => {
  return customFetch<DiscoveryCountResponse>(getDiscoveryCountUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getDiscoveryCountQueryKey = (params?: DiscoveryCountParams) => {
  return [`/api/discovery/count`, ...(params ? [params] : [])] as const;
};

export const getDiscoveryCountQueryOptions = <
  TData = Awaited<ReturnType<typeof discoveryCount>>,
  TError = ErrorType<unknown>,
>(
  params?: DiscoveryCountParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof discoveryCount>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDiscoveryCountQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof discoveryCount>>> = ({
    signal,
  }) => discoveryCount(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof discoveryCount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DiscoveryCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof discoveryCount>>
>;
export type DiscoveryCountQueryError = ErrorType<unknown>;

/**
 * @summary Total + facets only
 */

export function useDiscoveryCount<
  TData = Awaited<ReturnType<typeof discoveryCount>>,
  TError = ErrorType<unknown>,
>(
  params?: DiscoveryCountParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof discoveryCount>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDiscoveryCountQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Needs a session (401 otherwise). Newest unlock first. Sellers that are no longer in the catalogue are included with in_catalogue false: what was paid for stays visible.

 * @summary Sellers the current user has unlocked ("My contacts")
 */
export const getListUnlockedSellersUrl = (
  params?: ListUnlockedSellersParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/discovery/unlocked?${stringifiedParams}`
    : `/api/discovery/unlocked`;
};

export const listUnlockedSellers = async (
  params?: ListUnlockedSellersParams,
  options?: RequestInit,
): Promise<UnlockedSellersResponse> => {
  return customFetch<UnlockedSellersResponse>(
    getListUnlockedSellersUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListUnlockedSellersQueryKey = (
  params?: ListUnlockedSellersParams,
) => {
  return [`/api/discovery/unlocked`, ...(params ? [params] : [])] as const;
};

export const getListUnlockedSellersQueryOptions = <
  TData = Awaited<ReturnType<typeof listUnlockedSellers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListUnlockedSellersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listUnlockedSellers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListUnlockedSellersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listUnlockedSellers>>
  > = ({ signal }) =>
    listUnlockedSellers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUnlockedSellers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListUnlockedSellersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUnlockedSellers>>
>;
export type ListUnlockedSellersQueryError = ErrorType<unknown>;

/**
 * @summary Sellers the current user has unlocked ("My contacts")
 */

export function useListUnlockedSellers<
  TData = Awaited<ReturnType<typeof listUnlockedSellers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListUnlockedSellersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listUnlockedSellers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListUnlockedSellersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Find a seller from a pasted Amazon link, website or Seller ID
 */
export const getLookupSellerUrl = (params: LookupSellerParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/discovery/lookup?${stringifiedParams}`
    : `/api/discovery/lookup`;
};

export const lookupSeller = async (
  params: LookupSellerParams,
  options?: RequestInit,
): Promise<SellerLookupResponse> => {
  return customFetch<SellerLookupResponse>(getLookupSellerUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getLookupSellerQueryKey = (params?: LookupSellerParams) => {
  return [`/api/discovery/lookup`, ...(params ? [params] : [])] as const;
};

export const getLookupSellerQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupSeller>>,
  TError = ErrorType<unknown>,
>(
  params: LookupSellerParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof lookupSeller>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLookupSellerQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof lookupSeller>>> = ({
    signal,
  }) => lookupSeller(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupSeller>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LookupSellerQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupSeller>>
>;
export type LookupSellerQueryError = ErrorType<unknown>;

/**
 * @summary Find a seller from a pasted Amazon link, website or Seller ID
 */

export function useLookupSeller<
  TData = Awaited<ReturnType<typeof lookupSeller>>,
  TError = ErrorType<unknown>,
>(
  params: LookupSellerParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof lookupSeller>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLookupSellerQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single seller (no contact unless previously unlocked)
 */
export const getGetSellerUrl = (recordId: string) => {
  return `/api/discovery/seller/${recordId}`;
};

export const getSeller = async (
  recordId: string,
  options?: RequestInit,
): Promise<SellerDetail> => {
  return customFetch<SellerDetail>(getGetSellerUrl(recordId), {
    ...options,
    method: "GET",
  });
};

export const getGetSellerQueryKey = (recordId: string) => {
  return [`/api/discovery/seller/${recordId}`] as const;
};

export const getGetSellerQueryOptions = <
  TData = Awaited<ReturnType<typeof getSeller>>,
  TError = ErrorType<unknown>,
>(
  recordId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSeller>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSellerQueryKey(recordId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeller>>> = ({
    signal,
  }) => getSeller(recordId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!recordId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getSeller>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetSellerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSeller>>
>;
export type GetSellerQueryError = ErrorType<unknown>;

/**
 * @summary Get a single seller (no contact unless previously unlocked)
 */

export function useGetSeller<
  TData = Awaited<ReturnType<typeof getSeller>>,
  TError = ErrorType<unknown>,
>(
  recordId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSeller>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSellerQueryOptions(recordId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * `locked` sin desbloquear (nunca lleva el texto), `unavailable` si el seller no tiene contactos o Seller ID, `ready` con asunto y frase, y `writing` mientras el worker la escribe: esta misma llamada la encola, y la pantalla vuelve a preguntar hasta que este lista.

 * @summary The ready-to-send opening line for a seller the user has unlocked
 */
export const getGetSellerOpenerUrl = (recordId: string) => {
  return `/api/discovery/seller/${recordId}/opener`;
};

export const getSellerOpener = async (
  recordId: string,
  options?: RequestInit,
): Promise<SellerOpener> => {
  return customFetch<SellerOpener>(getGetSellerOpenerUrl(recordId), {
    ...options,
    method: "GET",
  });
};

export const getGetSellerOpenerQueryKey = (recordId: string) => {
  return [`/api/discovery/seller/${recordId}/opener`] as const;
};

export const getGetSellerOpenerQueryOptions = <
  TData = Awaited<ReturnType<typeof getSellerOpener>>,
  TError = ErrorType<unknown>,
>(
  recordId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSellerOpener>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSellerOpenerQueryKey(recordId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSellerOpener>>> = ({
    signal,
  }) => getSellerOpener(recordId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!recordId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSellerOpener>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSellerOpenerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSellerOpener>>
>;
export type GetSellerOpenerQueryError = ErrorType<unknown>;

/**
 * @summary The ready-to-send opening line for a seller the user has unlocked
 */

export function useGetSellerOpener<
  TData = Awaited<ReturnType<typeof getSellerOpener>>,
  TError = ErrorType<unknown>,
>(
  recordId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSellerOpener>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSellerOpenerQueryOptions(recordId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Spend a credit and reveal contact info
 */
export const getUnlockSellerUrl = (recordId: string) => {
  return `/api/discovery/seller/${recordId}/unlock`;
};

export const unlockSeller = async (
  recordId: string,
  options?: RequestInit,
): Promise<UnlockResponse> => {
  return customFetch<UnlockResponse>(getUnlockSellerUrl(recordId), {
    ...options,
    method: "POST",
  });
};

export const getUnlockSellerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlockSeller>>,
    TError,
    { recordId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlockSeller>>,
  TError,
  { recordId: string },
  TContext
> => {
  const mutationKey = ["unlockSeller"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlockSeller>>,
    { recordId: string }
  > = (props) => {
    const { recordId } = props ?? {};

    return unlockSeller(recordId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlockSellerMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlockSeller>>
>;

export type UnlockSellerMutationError = ErrorType<unknown>;

/**
 * @summary Spend a credit and reveal contact info
 */
export const useUnlockSeller = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlockSeller>>,
    TError,
    { recordId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlockSeller>>,
  TError,
  { recordId: string },
  TContext
> => {
  return useMutation(getUnlockSellerMutationOptions(options));
};

/**
 * @summary All saved lists for the current user
 */
export const getListListsUrl = () => {
  return `/api/lists`;
};

export const listLists = async (
  options?: RequestInit,
): Promise<SavedList[]> => {
  return customFetch<SavedList[]>(getListListsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListListsQueryKey = () => {
  return [`/api/lists`] as const;
};

export const getListListsQueryOptions = <
  TData = Awaited<ReturnType<typeof listLists>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listLists>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListListsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLists>>> = ({
    signal,
  }) => listLists({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLists>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListListsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLists>>
>;
export type ListListsQueryError = ErrorType<unknown>;

/**
 * @summary All saved lists for the current user
 */

export function useListLists<
  TData = Awaited<ReturnType<typeof listLists>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listLists>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListListsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a saved list
 */
export const getCreateListUrl = () => {
  return `/api/lists`;
};

export const createList = async (
  createListBody: CreateListBody,
  options?: RequestInit,
): Promise<SavedList> => {
  return customFetch<SavedList>(getCreateListUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createListBody),
  });
};

export const getCreateListMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createList>>,
    TError,
    { data: BodyType<CreateListBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createList>>,
  TError,
  { data: BodyType<CreateListBody> },
  TContext
> => {
  const mutationKey = ["createList"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createList>>,
    { data: BodyType<CreateListBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createList(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateListMutationResult = NonNullable<
  Awaited<ReturnType<typeof createList>>
>;
export type CreateListMutationBody = BodyType<CreateListBody>;
export type CreateListMutationError = ErrorType<unknown>;

/**
 * @summary Create a saved list
 */
export const useCreateList = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createList>>,
    TError,
    { data: BodyType<CreateListBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createList>>,
  TError,
  { data: BodyType<CreateListBody> },
  TContext
> => {
  return useMutation(getCreateListMutationOptions(options));
};

/**
 * @summary Get a saved list
 */
export const getGetListUrl = (id: string) => {
  return `/api/lists/${id}`;
};

export const getList = async (
  id: string,
  options?: RequestInit,
): Promise<SavedList> => {
  return customFetch<SavedList>(getGetListUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetListQueryKey = (id: string) => {
  return [`/api/lists/${id}`] as const;
};

export const getGetListQueryOptions = <
  TData = Awaited<ReturnType<typeof getList>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetListQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getList>>> = ({
    signal,
  }) => getList(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getList>>
>;
export type GetListQueryError = ErrorType<unknown>;

/**
 * @summary Get a saved list
 */

export function useGetList<
  TData = Awaited<ReturnType<typeof getList>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetListQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a saved list
 */
export const getUpdateListUrl = (id: string) => {
  return `/api/lists/${id}`;
};

export const updateList = async (
  id: string,
  updateListBody: UpdateListBody,
  options?: RequestInit,
): Promise<SavedList> => {
  return customFetch<SavedList>(getUpdateListUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateListBody),
  });
};

export const getUpdateListMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateList>>,
    TError,
    { id: string; data: BodyType<UpdateListBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateList>>,
  TError,
  { id: string; data: BodyType<UpdateListBody> },
  TContext
> => {
  const mutationKey = ["updateList"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateList>>,
    { id: string; data: BodyType<UpdateListBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateList(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateListMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateList>>
>;
export type UpdateListMutationBody = BodyType<UpdateListBody>;
export type UpdateListMutationError = ErrorType<unknown>;

/**
 * @summary Update a saved list
 */
export const useUpdateList = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateList>>,
    TError,
    { id: string; data: BodyType<UpdateListBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateList>>,
  TError,
  { id: string; data: BodyType<UpdateListBody> },
  TContext
> => {
  return useMutation(getUpdateListMutationOptions(options));
};

/**
 * @summary Delete a saved list
 */
export const getDeleteListUrl = (id: string) => {
  return `/api/lists/${id}`;
};

export const deleteList = async (
  id: string,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDeleteListUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteListMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteList>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteList>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteList"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteList>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteList(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteListMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteList>>
>;

export type DeleteListMutationError = ErrorType<unknown>;

/**
 * @summary Delete a saved list
 */
export const useDeleteList = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteList>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteList>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteListMutationOptions(options));
};

/**
 * Con `unlock`, antes de exportar desbloquea las filas que siguen bloqueadas y cuyo contacto principal trae un email, un movil o su LinkedIn, a un credito cada una. Todo o nada: 402 si no hay creditos para todas y 409 si hacen falta mas que `max_credits`; en los dos casos no se cobra nada.

 * @summary Export filtered seller records as CSV (returns CSV body as text)
 */
export const getExportRecordsUrl = () => {
  return `/api/export`;
};

export const exportRecords = async (
  exportBody: ExportBody,
  options?: RequestInit,
): Promise<ExportResult> => {
  return customFetch<ExportResult>(getExportRecordsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(exportBody),
  });
};

export const getExportRecordsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportRecords>>,
    TError,
    { data: BodyType<ExportBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportRecords>>,
  TError,
  { data: BodyType<ExportBody> },
  TContext
> => {
  const mutationKey = ["exportRecords"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportRecords>>,
    { data: BodyType<ExportBody> }
  > = (props) => {
    const { data } = props ?? {};

    return exportRecords(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportRecordsMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportRecords>>
>;
export type ExportRecordsMutationBody = BodyType<ExportBody>;
export type ExportRecordsMutationError = ErrorType<unknown>;

/**
 * @summary Export filtered seller records as CSV (returns CSV body as text)
 */
export const useExportRecords = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportRecords>>,
    TError,
    { data: BodyType<ExportBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof exportRecords>>,
  TError,
  { data: BodyType<ExportBody> },
  TContext
> => {
  return useMutation(getExportRecordsMutationOptions(options));
};

/**
 * Mismas filas que el export con el mismo cuerpo (filtro, seleccion y limite). Lo pide el dialogo de export antes de ofrecer "Unlock contacts and download", y su `to_unlock` es el `max_credits` que se manda luego.

 * @summary How many credits unlocking an export would spend. Charges nothing.
 */
export const getQuoteExportUrl = () => {
  return `/api/export/quote`;
};

export const quoteExport = async (
  exportBody: ExportBody,
  options?: RequestInit,
): Promise<ExportQuote> => {
  return customFetch<ExportQuote>(getQuoteExportUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(exportBody),
  });
};

export const getQuoteExportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof quoteExport>>,
    TError,
    { data: BodyType<ExportBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof quoteExport>>,
  TError,
  { data: BodyType<ExportBody> },
  TContext
> => {
  const mutationKey = ["quoteExport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof quoteExport>>,
    { data: BodyType<ExportBody> }
  > = (props) => {
    const { data } = props ?? {};

    return quoteExport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type QuoteExportMutationResult = NonNullable<
  Awaited<ReturnType<typeof quoteExport>>
>;
export type QuoteExportMutationBody = BodyType<ExportBody>;
export type QuoteExportMutationError = ErrorType<unknown>;

/**
 * @summary How many credits unlocking an export would spend. Charges nothing.
 */
export const useQuoteExport = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof quoteExport>>,
    TError,
    { data: BodyType<ExportBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof quoteExport>>,
  TError,
  { data: BodyType<ExportBody> },
  TContext
> => {
  return useMutation(getQuoteExportMutationOptions(options));
};

/**
 * Publico y sin sesion: es el CTA principal del sitio. Guarda la solicitud y avisa por correo. Limitado por IP.

 * @summary Request a custom sample from the marketing site
 */
export const getCreateSampleRequestUrl = () => {
  return `/api/sample-requests`;
};

export const createSampleRequest = async (
  sampleRequestBody: SampleRequestBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getCreateSampleRequestUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sampleRequestBody),
  });
};

export const getCreateSampleRequestMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSampleRequest>>,
    TError,
    { data: BodyType<SampleRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSampleRequest>>,
  TError,
  { data: BodyType<SampleRequestBody> },
  TContext
> => {
  const mutationKey = ["createSampleRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSampleRequest>>,
    { data: BodyType<SampleRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSampleRequest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSampleRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSampleRequest>>
>;
export type CreateSampleRequestMutationBody = BodyType<SampleRequestBody>;
export type CreateSampleRequestMutationError = ErrorType<unknown>;

/**
 * @summary Request a custom sample from the marketing site
 */
export const useCreateSampleRequest = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSampleRequest>>,
    TError,
    { data: BodyType<SampleRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSampleRequest>>,
  TError,
  { data: BodyType<SampleRequestBody> },
  TContext
> => {
  return useMutation(getCreateSampleRequestMutationOptions(options));
};

/**
 * @summary Inbox of UI-anchored notes
 */
export const getListNotesUrl = (params?: ListNotesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/notes?${stringifiedParams}`
    : `/api/notes`;
};

export const listNotes = async (
  params?: ListNotesParams,
  options?: RequestInit,
): Promise<NoteListResponse> => {
  return customFetch<NoteListResponse>(getListNotesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListNotesQueryKey = (params?: ListNotesParams) => {
  return [`/api/notes`, ...(params ? [params] : [])] as const;
};

export const getListNotesQueryOptions = <
  TData = Awaited<ReturnType<typeof listNotes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListNotesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listNotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListNotesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotes>>> = ({
    signal,
  }) => listNotes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listNotes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListNotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNotes>>
>;
export type ListNotesQueryError = ErrorType<unknown>;

/**
 * @summary Inbox of UI-anchored notes
 */

export function useListNotes<
  TData = Awaited<ReturnType<typeof listNotes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListNotesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listNotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListNotesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Leave a note anchored to an element (or to the page)
 */
export const getCreateNoteUrl = () => {
  return `/api/notes`;
};

export const createNote = async (
  createNoteBody: CreateNoteBody,
  options?: RequestInit,
): Promise<Note> => {
  return customFetch<Note>(getCreateNoteUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createNoteBody),
  });
};

export const getCreateNoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNote>>,
    TError,
    { data: BodyType<CreateNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createNote>>,
  TError,
  { data: BodyType<CreateNoteBody> },
  TContext
> => {
  const mutationKey = ["createNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createNote>>,
    { data: BodyType<CreateNoteBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createNote(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof createNote>>
>;
export type CreateNoteMutationBody = BodyType<CreateNoteBody>;
export type CreateNoteMutationError = ErrorType<unknown>;

/**
 * @summary Leave a note anchored to an element (or to the page)
 */
export const useCreateNote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNote>>,
    TError,
    { data: BodyType<CreateNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createNote>>,
  TError,
  { data: BodyType<CreateNoteBody> },
  TContext
> => {
  return useMutation(getCreateNoteMutationOptions(options));
};

/**
 * @summary Per-page context for the widget (badge, pins, deep-link target)
 */
export const getGetNoteContextUrl = (params: GetNoteContextParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/notes/context?${stringifiedParams}`
    : `/api/notes/context`;
};

export const getNoteContext = async (
  params: GetNoteContextParams,
  options?: RequestInit,
): Promise<NoteContext> => {
  return customFetch<NoteContext>(getGetNoteContextUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetNoteContextQueryKey = (params?: GetNoteContextParams) => {
  return [`/api/notes/context`, ...(params ? [params] : [])] as const;
};

export const getGetNoteContextQueryOptions = <
  TData = Awaited<ReturnType<typeof getNoteContext>>,
  TError = ErrorType<unknown>,
>(
  params: GetNoteContextParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNoteContext>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNoteContextQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNoteContext>>> = ({
    signal,
  }) => getNoteContext(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNoteContext>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNoteContextQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNoteContext>>
>;
export type GetNoteContextQueryError = ErrorType<unknown>;

/**
 * @summary Per-page context for the widget (badge, pins, deep-link target)
 */

export function useGetNoteContext<
  TData = Awaited<ReturnType<typeof getNoteContext>>,
  TError = ErrorType<unknown>,
>(
  params: GetNoteContextParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNoteContext>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNoteContextQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Resolve or reopen a note
 */
export const getSetNoteStatusUrl = (id: string) => {
  return `/api/notes/${id}`;
};

export const setNoteStatus = async (
  id: string,
  updateNoteStatusBody: UpdateNoteStatusBody,
  options?: RequestInit,
): Promise<Note> => {
  return customFetch<Note>(getSetNoteStatusUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateNoteStatusBody),
  });
};

export const getSetNoteStatusMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setNoteStatus>>,
    TError,
    { id: string; data: BodyType<UpdateNoteStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setNoteStatus>>,
  TError,
  { id: string; data: BodyType<UpdateNoteStatusBody> },
  TContext
> => {
  const mutationKey = ["setNoteStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setNoteStatus>>,
    { id: string; data: BodyType<UpdateNoteStatusBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return setNoteStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetNoteStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof setNoteStatus>>
>;
export type SetNoteStatusMutationBody = BodyType<UpdateNoteStatusBody>;
export type SetNoteStatusMutationError = ErrorType<unknown>;

/**
 * @summary Resolve or reopen a note
 */
export const useSetNoteStatus = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setNoteStatus>>,
    TError,
    { id: string; data: BodyType<UpdateNoteStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setNoteStatus>>,
  TError,
  { id: string; data: BodyType<UpdateNoteStatusBody> },
  TContext
> => {
  return useMutation(getSetNoteStatusMutationOptions(options));
};

/**
 * @summary Reply in a note thread
 */
export const getCommentOnNoteUrl = (id: string) => {
  return `/api/notes/${id}/comments`;
};

export const commentOnNote = async (
  id: string,
  createNoteCommentBody: CreateNoteCommentBody,
  options?: RequestInit,
): Promise<Note> => {
  return customFetch<Note>(getCommentOnNoteUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createNoteCommentBody),
  });
};

export const getCommentOnNoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof commentOnNote>>,
    TError,
    { id: string; data: BodyType<CreateNoteCommentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof commentOnNote>>,
  TError,
  { id: string; data: BodyType<CreateNoteCommentBody> },
  TContext
> => {
  const mutationKey = ["commentOnNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof commentOnNote>>,
    { id: string; data: BodyType<CreateNoteCommentBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return commentOnNote(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CommentOnNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof commentOnNote>>
>;
export type CommentOnNoteMutationBody = BodyType<CreateNoteCommentBody>;
export type CommentOnNoteMutationError = ErrorType<unknown>;

/**
 * @summary Reply in a note thread
 */
export const useCommentOnNote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof commentOnNote>>,
    TError,
    { id: string; data: BodyType<CreateNoteCommentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof commentOnNote>>,
  TError,
  { id: string; data: BodyType<CreateNoteCommentBody> },
  TContext
> => {
  return useMutation(getCommentOnNoteMutationOptions(options));
};

/**
 * @summary Tandas del usuario, la mas reciente primero
 */
export const getListPipelineRunsUrl = () => {
  return `/api/pipeline/runs`;
};

export const listPipelineRuns = async (
  options?: RequestInit,
): Promise<ListPipelineRunsResponse> => {
  return customFetch<ListPipelineRunsResponse>(getListPipelineRunsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListPipelineRunsQueryKey = () => {
  return [`/api/pipeline/runs`] as const;
};

export const getListPipelineRunsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPipelineRuns>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPipelineRuns>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPipelineRunsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPipelineRuns>>
  > = ({ signal }) => listPipelineRuns({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPipelineRuns>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPipelineRunsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPipelineRuns>>
>;
export type ListPipelineRunsQueryError = ErrorType<unknown>;

/**
 * @summary Tandas del usuario, la mas reciente primero
 */

export function useListPipelineRuns<
  TData = Awaited<ReturnType<typeof listPipelineRuns>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPipelineRuns>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPipelineRunsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Crear una tanda a partir de un CSV de SmartScout
 */
export const getCreatePipelineRunUrl = () => {
  return `/api/pipeline/runs`;
};

export const createPipelineRun = async (
  createPipelineRunBody: CreatePipelineRunBody,
  options?: RequestInit,
): Promise<PipelineRun> => {
  return customFetch<PipelineRun>(getCreatePipelineRunUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPipelineRunBody),
  });
};

export const getCreatePipelineRunMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPipelineRun>>,
    TError,
    { data: BodyType<CreatePipelineRunBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPipelineRun>>,
  TError,
  { data: BodyType<CreatePipelineRunBody> },
  TContext
> => {
  const mutationKey = ["createPipelineRun"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPipelineRun>>,
    { data: BodyType<CreatePipelineRunBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createPipelineRun(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePipelineRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPipelineRun>>
>;
export type CreatePipelineRunMutationBody = BodyType<CreatePipelineRunBody>;
export type CreatePipelineRunMutationError = ErrorType<void>;

/**
 * @summary Crear una tanda a partir de un CSV de SmartScout
 */
export const useCreatePipelineRun = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPipelineRun>>,
    TError,
    { data: BodyType<CreatePipelineRunBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPipelineRun>>,
  TError,
  { data: BodyType<CreatePipelineRunBody> },
  TContext
> => {
  return useMutation(getCreatePipelineRunMutationOptions(options));
};

/**
 * @summary Estado, progreso y resultados de una tanda
 */
export const getGetPipelineRunUrl = (
  id: string,
  params?: GetPipelineRunParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/pipeline/runs/${id}?${stringifiedParams}`
    : `/api/pipeline/runs/${id}`;
};

export const getPipelineRun = async (
  id: string,
  params?: GetPipelineRunParams,
  options?: RequestInit,
): Promise<GetPipelineRunResponse> => {
  return customFetch<GetPipelineRunResponse>(getGetPipelineRunUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getGetPipelineRunQueryKey = (
  id: string,
  params?: GetPipelineRunParams,
) => {
  return [`/api/pipeline/runs/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetPipelineRunQueryOptions = <
  TData = Awaited<ReturnType<typeof getPipelineRun>>,
  TError = ErrorType<void>,
>(
  id: string,
  params?: GetPipelineRunParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPipelineRun>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPipelineRunQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPipelineRun>>> = ({
    signal,
  }) => getPipelineRun(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPipelineRun>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPipelineRunQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPipelineRun>>
>;
export type GetPipelineRunQueryError = ErrorType<void>;

/**
 * @summary Estado, progreso y resultados de una tanda
 */

export function useGetPipelineRun<
  TData = Awaited<ReturnType<typeof getPipelineRun>>,
  TError = ErrorType<void>,
>(
  id: string,
  params?: GetPipelineRunParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPipelineRun>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPipelineRunQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Paso EXPLICITO a proposito: el catalogo es lo que ve un cliente y una tanda es material en revision. Ademas marca los sellers procesados con `last_enriched_at`, incluidos los que no dieron contactos, para no volver a pagar por ellos.

 * @summary Pasar los resultados de una tanda al catalogo
 */
export const getPromotePipelineRunUrl = (id: string) => {
  return `/api/pipeline/runs/${id}/promote`;
};

export const promotePipelineRun = async (
  id: string,
  options?: RequestInit,
): Promise<PromotePipelineRunResponse> => {
  return customFetch<PromotePipelineRunResponse>(getPromotePipelineRunUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getPromotePipelineRunMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promotePipelineRun>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof promotePipelineRun>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["promotePipelineRun"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof promotePipelineRun>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return promotePipelineRun(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PromotePipelineRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof promotePipelineRun>>
>;

export type PromotePipelineRunMutationError = ErrorType<void>;

/**
 * @summary Pasar los resultados de una tanda al catalogo
 */
export const usePromotePipelineRun = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promotePipelineRun>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof promotePipelineRun>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getPromotePipelineRunMutationOptions(options));
};

/**
 * Para el "Run lead gen" de /discovery (Daisy, 25-09-2026): en vez de subir un fichero, se eligen sellers que ya estan en el catalogo. El CSV se construye en el servidor, desde la fila completa, porque la busqueda no trae la razon social y sin ella se confirman menos dominios. No lanza nada: la tanda se crea despues por el flujo normal de /pipeline, con sus topes y su validacion.

 * @summary El CSV de una tanda, construido desde sellers del catalogo
 */
export const getSeedPipelineFromSellersUrl = () => {
  return `/api/pipeline/seed`;
};

export const seedPipelineFromSellers = async (
  seedPipelineBody: SeedPipelineBody,
  options?: RequestInit,
): Promise<SeedPipelineResponse> => {
  return customFetch<SeedPipelineResponse>(getSeedPipelineFromSellersUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(seedPipelineBody),
  });
};

export const getSeedPipelineFromSellersMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof seedPipelineFromSellers>>,
    TError,
    { data: BodyType<SeedPipelineBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof seedPipelineFromSellers>>,
  TError,
  { data: BodyType<SeedPipelineBody> },
  TContext
> => {
  const mutationKey = ["seedPipelineFromSellers"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof seedPipelineFromSellers>>,
    { data: BodyType<SeedPipelineBody> }
  > = (props) => {
    const { data } = props ?? {};

    return seedPipelineFromSellers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SeedPipelineFromSellersMutationResult = NonNullable<
  Awaited<ReturnType<typeof seedPipelineFromSellers>>
>;
export type SeedPipelineFromSellersMutationBody = BodyType<SeedPipelineBody>;
export type SeedPipelineFromSellersMutationError = ErrorType<unknown>;

/**
 * @summary El CSV de una tanda, construido desde sellers del catalogo
 */
export const useSeedPipelineFromSellers = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof seedPipelineFromSellers>>,
    TError,
    { data: BodyType<SeedPipelineBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof seedPipelineFromSellers>>,
  TError,
  { data: BodyType<SeedPipelineBody> },
  TContext
> => {
  return useMutation(getSeedPipelineFromSellersMutationOptions(options));
};

/**
 * @summary Importaciones de SmartScout recientes de quien pregunta
 */
export const getListSmartscoutImportsUrl = () => {
  return `/api/pipeline/imports`;
};

export const listSmartscoutImports = async (
  options?: RequestInit,
): Promise<SmartscoutImportList> => {
  return customFetch<SmartscoutImportList>(getListSmartscoutImportsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSmartscoutImportsQueryKey = () => {
  return [`/api/pipeline/imports`] as const;
};

export const getListSmartscoutImportsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSmartscoutImports>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSmartscoutImports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSmartscoutImportsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSmartscoutImports>>
  > = ({ signal }) => listSmartscoutImports({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSmartscoutImports>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSmartscoutImportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSmartscoutImports>>
>;
export type ListSmartscoutImportsQueryError = ErrorType<unknown>;

/**
 * @summary Importaciones de SmartScout recientes de quien pregunta
 */

export function useListSmartscoutImports<
  TData = Awaited<ReturnType<typeof listSmartscoutImports>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSmartscoutImports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSmartscoutImportsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Refresco trimestral del catalogo (opcion B, 01-10-2026). Solo crea la importacion y fija las columnas; las filas llegan despues en bloques (el proxy corta a 2 MB y un lote son ~50 MB). Nada toca el catalogo hasta /apply.

 * @summary Empezar a subir un export de la tabla Sellers de SmartScout
 */
export const getCreateSmartscoutImportUrl = () => {
  return `/api/pipeline/imports`;
};

export const createSmartscoutImport = async (
  createSmartscoutImportBody: CreateSmartscoutImportBody,
  options?: RequestInit,
): Promise<SmartscoutImport> => {
  return customFetch<SmartscoutImport>(getCreateSmartscoutImportUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSmartscoutImportBody),
  });
};

export const getCreateSmartscoutImportMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSmartscoutImport>>,
    TError,
    { data: BodyType<CreateSmartscoutImportBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSmartscoutImport>>,
  TError,
  { data: BodyType<CreateSmartscoutImportBody> },
  TContext
> => {
  const mutationKey = ["createSmartscoutImport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSmartscoutImport>>,
    { data: BodyType<CreateSmartscoutImportBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSmartscoutImport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSmartscoutImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSmartscoutImport>>
>;
export type CreateSmartscoutImportMutationBody =
  BodyType<CreateSmartscoutImportBody>;
export type CreateSmartscoutImportMutationError = ErrorType<void>;

/**
 * @summary Empezar a subir un export de la tabla Sellers de SmartScout
 */
export const useCreateSmartscoutImport = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSmartscoutImport>>,
    TError,
    { data: BodyType<CreateSmartscoutImportBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSmartscoutImport>>,
  TError,
  { data: BodyType<CreateSmartscoutImportBody> },
  TContext
> => {
  return useMutation(getCreateSmartscoutImportMutationOptions(options));
};

/**
 * @summary Un bloque de filas ya leidas del CSV
 */
export const getAddSmartscoutImportRowsUrl = (id: string) => {
  return `/api/pipeline/imports/${id}/rows`;
};

export const addSmartscoutImportRows = async (
  id: string,
  addSmartscoutImportRowsBody: AddSmartscoutImportRowsBody,
  options?: RequestInit,
): Promise<AddSmartscoutImportRowsResponse> => {
  return customFetch<AddSmartscoutImportRowsResponse>(
    getAddSmartscoutImportRowsUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(addSmartscoutImportRowsBody),
    },
  );
};

export const getAddSmartscoutImportRowsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addSmartscoutImportRows>>,
    TError,
    { id: string; data: BodyType<AddSmartscoutImportRowsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addSmartscoutImportRows>>,
  TError,
  { id: string; data: BodyType<AddSmartscoutImportRowsBody> },
  TContext
> => {
  const mutationKey = ["addSmartscoutImportRows"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addSmartscoutImportRows>>,
    { id: string; data: BodyType<AddSmartscoutImportRowsBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return addSmartscoutImportRows(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddSmartscoutImportRowsMutationResult = NonNullable<
  Awaited<ReturnType<typeof addSmartscoutImportRows>>
>;
export type AddSmartscoutImportRowsMutationBody =
  BodyType<AddSmartscoutImportRowsBody>;
export type AddSmartscoutImportRowsMutationError = ErrorType<unknown>;

/**
 * @summary Un bloque de filas ya leidas del CSV
 */
export const useAddSmartscoutImportRows = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addSmartscoutImportRows>>,
    TError,
    { id: string; data: BodyType<AddSmartscoutImportRowsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addSmartscoutImportRows>>,
  TError,
  { id: string; data: BodyType<AddSmartscoutImportRowsBody> },
  TContext
> => {
  return useMutation(getAddSmartscoutImportRowsMutationOptions(options));
};

/**
 * @summary Que pasaria al importar, sin tocar el catalogo
 */
export const getReviewSmartscoutImportUrl = (id: string) => {
  return `/api/pipeline/imports/${id}/review`;
};

export const reviewSmartscoutImport = async (
  id: string,
  options?: RequestInit,
): Promise<SmartscoutImport> => {
  return customFetch<SmartscoutImport>(getReviewSmartscoutImportUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getReviewSmartscoutImportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reviewSmartscoutImport>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reviewSmartscoutImport>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["reviewSmartscoutImport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reviewSmartscoutImport>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return reviewSmartscoutImport(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReviewSmartscoutImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof reviewSmartscoutImport>>
>;

export type ReviewSmartscoutImportMutationError = ErrorType<unknown>;

/**
 * @summary Que pasaria al importar, sin tocar el catalogo
 */
export const useReviewSmartscoutImport = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reviewSmartscoutImport>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reviewSmartscoutImport>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getReviewSmartscoutImportMutationOptions(options));
};

/**
 * @summary Aplicar una importacion revisada al catalogo
 */
export const getApplySmartscoutImportUrl = (id: string) => {
  return `/api/pipeline/imports/${id}/apply`;
};

export const applySmartscoutImport = async (
  id: string,
  options?: RequestInit,
): Promise<SmartscoutImport> => {
  return customFetch<SmartscoutImport>(getApplySmartscoutImportUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getApplySmartscoutImportMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applySmartscoutImport>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applySmartscoutImport>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["applySmartscoutImport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applySmartscoutImport>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return applySmartscoutImport(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplySmartscoutImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof applySmartscoutImport>>
>;

export type ApplySmartscoutImportMutationError = ErrorType<void>;

/**
 * @summary Aplicar una importacion revisada al catalogo
 */
export const useApplySmartscoutImport = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applySmartscoutImport>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof applySmartscoutImport>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getApplySmartscoutImportMutationOptions(options));
};

/**
 * @summary Limites vigentes y gasto del mes en curso
 */
export const getGetPipelineLimitsUrl = () => {
  return `/api/pipeline/limits`;
};

export const getPipelineLimits = async (
  options?: RequestInit,
): Promise<GetPipelineLimitsResponse> => {
  return customFetch<GetPipelineLimitsResponse>(getGetPipelineLimitsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPipelineLimitsQueryKey = () => {
  return [`/api/pipeline/limits`] as const;
};

export const getGetPipelineLimitsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPipelineLimits>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPipelineLimits>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPipelineLimitsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPipelineLimits>>
  > = ({ signal }) => getPipelineLimits({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPipelineLimits>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPipelineLimitsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPipelineLimits>>
>;
export type GetPipelineLimitsQueryError = ErrorType<unknown>;

/**
 * @summary Limites vigentes y gasto del mes en curso
 */

export function useGetPipelineLimits<
  TData = Awaited<ReturnType<typeof getPipelineLimits>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPipelineLimits>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPipelineLimitsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Cambiar los limites
 */
export const getUpdatePipelineLimitsUrl = () => {
  return `/api/pipeline/limits`;
};

export const updatePipelineLimits = async (
  updatePipelineLimitsBody: UpdatePipelineLimitsBody,
  options?: RequestInit,
): Promise<GetPipelineLimitsResponse> => {
  return customFetch<GetPipelineLimitsResponse>(getUpdatePipelineLimitsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updatePipelineLimitsBody),
  });
};

export const getUpdatePipelineLimitsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePipelineLimits>>,
    TError,
    { data: BodyType<UpdatePipelineLimitsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePipelineLimits>>,
  TError,
  { data: BodyType<UpdatePipelineLimitsBody> },
  TContext
> => {
  const mutationKey = ["updatePipelineLimits"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePipelineLimits>>,
    { data: BodyType<UpdatePipelineLimitsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updatePipelineLimits(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePipelineLimitsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePipelineLimits>>
>;
export type UpdatePipelineLimitsMutationBody =
  BodyType<UpdatePipelineLimitsBody>;
export type UpdatePipelineLimitsMutationError = ErrorType<unknown>;

/**
 * @summary Cambiar los limites
 */
export const useUpdatePipelineLimits = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePipelineLimits>>,
    TError,
    { data: BodyType<UpdatePipelineLimitsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePipelineLimits>>,
  TError,
  { data: BodyType<UpdatePipelineLimitsBody> },
  TContext
> => {
  return useMutation(getUpdatePipelineLimitsMutationOptions(options));
};
